import React from "react";
import { ColumnsLayout, Disclaimer } from "@components";

export const DisclaimerPage = () => {
  return (
    <ColumnsLayout>
      <Disclaimer />
    </ColumnsLayout>
  );
};
